module.exports = __webpack_public_path__ + "static/media/hdd.a6bab47f.svg";